export function searchAjax() {
  (function () {
    const container    = document.getElementById('tdf-search-container');
    if (!container) return;

    const resultsEl    = document.getElementById('tdf-results');
    const paginationEl = document.getElementById('tdf-pagination');
    const orderbyEl    = document.getElementById('tdf-orderby');
    const orderDirBtn  = document.getElementById('tdf-orderdir');
    const viewBtns     = document.querySelectorAll('.search__view-btn');
    const form         = document.getElementById('tdf-search-form');

    // --- state from URL then data-attrs
    const urlParams = new URLSearchParams(window.location.search);
    let state = {
      s:       urlParams.get('s')       ?? container.dataset.query   ?? '',
      orderby: urlParams.get('orderby') ?? container.dataset.orderby ?? 'relevance',
      order:   (urlParams.get('order') || container.dataset.order || 'DESC').toUpperCase() === 'ASC' ? 'ASC' : 'DESC',
      view:    urlParams.get('view')    ?? container.dataset.view    ?? 'list',
      paged:   parseInt(urlParams.get('paged') || container.dataset.paged || '1', 10),
    };

    function labelForType(t) {
      switch (t) {
        case 'show': return 'Shows';
        case 'page': return 'Programs';
        case 'other': return 'Articles & More';
        default: return 'Articles & More';
      }
    }

    function updateMastheadQuery() {
      const qSpan = document.getElementById('tdf-search-query');
      if (qSpan) qSpan.textContent = state.s || '';

      // Try to update the last breadcrumb label if RankMath (or similar) is present
      const bcLast =
        document.querySelector('.rank-math-breadcrumb .last') ||
        document.querySelector('.breadcrumbs .current') ||
        document.querySelector('nav[aria-label="breadcrumb"] li:last-child');

      if (bcLast) {
        const prefix = 'Search: ';
        bcLast.textContent = prefix + (state.s || '');
      }

      // Optional: keep the tab title tidy too
      try {
        const baseTitle = document.title.replace(/ – .+$/, '');
        document.title = (state.s ? `Search: ${state.s} – ${baseTitle}` : baseTitle);
      } catch (_) {}
    }

    function qsFromState() {
      const p = new URLSearchParams();
      if (state.s) p.set('s', state.s);
      if (state.orderby) p.set('orderby', state.orderby);
      if (state.order) p.set('order', state.order);
      if (state.view) p.set('view', state.view);
      if (state.paged > 1) p.set('paged', String(state.paged));
      return p.toString();
    }

    function pushUrl() {
      const qs = qsFromState();
      const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
      window.history.replaceState({}, '', url);
    }

    // --- Multiselect Dropdown (MSD) enhancer (uses your .msd* classes)
    function enhanceMultiSelect(selectEl) {
      if (!selectEl || selectEl.dataset.msdEnhanced === '1') return selectEl;

      // Wrap
      const wrap = document.createElement('div');
      wrap.className = 'farlo-ui-multi-select';
      const native = selectEl;
      native.classList.add('farlo-ui-multi-select__native');
      native.setAttribute('aria-hidden', 'true');
      native.tabIndex = -1;
      native.parentNode.insertBefore(wrap, native);
      wrap.appendChild(native);

      // Button
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'farlo-ui-multi-select__button';
      wrap.appendChild(btn);

      // Panel
      const panel = document.createElement('div');
      panel.className = 'farlo-ui-multi-select__panel';
      panel.hidden = true;
      wrap.appendChild(panel);

      // Controls
      const controls = document.createElement('div');
      controls.className = 'farlo-ui-multi-select__controls';

      const search = document.createElement('input');
      search.type = 'search';
      search.className = 'farlo-ui-multi-select__search';
      search.placeholder = 'Search...';

      const actions = document.createElement('div');
      actions.className = 'farlo-ui-multi-select__actions';

      const actAll = document.createElement('button');
      actAll.type = 'button';
      actAll.className = 'farlo-ui-multi-select__act';
      actAll.textContent = 'Select all';

      const actClear = document.createElement('button');
      actClear.type = 'button';
      actClear.className = 'farlo-ui-multi-select__act';
      actClear.textContent = 'Clear';

      actions.appendChild(actAll);
      actions.appendChild(actClear);
      controls.appendChild(search);
      controls.appendChild(actions);
      panel.appendChild(controls);

      // List
      const list = document.createElement('ul');
      list.className = 'farlo-ui-multi-select__list';
      panel.appendChild(list);

      function summary() {
        const selected = Array.from(native.selectedOptions).map(o => o.textContent.trim());
        if (selected.length === 0) return 'None selected';
        if (selected.length === native.options.length) return 'All selected';
        return selected.join(', ');
      }

      function rebuildList() {
        const q = search.value.trim().toLowerCase();
        list.innerHTML = '';
        Array.from(native.options).forEach(opt => {
          const label = (opt.textContent || '').trim();
          if (q && !label.toLowerCase().includes(q)) return;

          const li  = document.createElement('li');
          li.className = 'farlo-ui-multi-select__item';

          const lab = document.createElement('label');
          lab.className = 'farlo-ui-multi-select__label';

          const cb  = document.createElement('input');
          cb.type = 'checkbox';
          cb.className = 'farlo-ui-multi-select__checkbox';
          cb.checked = opt.selected;
          cb.addEventListener('change', () => {
            opt.selected = cb.checked;
            native.dispatchEvent(new Event('change', { bubbles: true }));
            btn.textContent = summary();
          });

          const span = document.createElement('span');
          span.textContent = label;

          lab.appendChild(cb);
          lab.appendChild(span);
          li.appendChild(lab);
          list.appendChild(li);
        });
      }

      function openPanel() {
        panel.hidden = false;
        btn.setAttribute('aria-expanded','true');
        search.focus();
      }
      function closePanel() {
        panel.hidden = true;
        btn.setAttribute('aria-expanded','false');
      }

      btn.addEventListener('click', () => { panel.hidden ? openPanel() : closePanel(); });
      document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) closePanel(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanel(); });

      actAll.addEventListener('click', () => {
        Array.from(native.options).forEach(o => { o.selected = true; });
        native.dispatchEvent(new Event('change', { bubbles: true }));
        btn.textContent = summary();
        rebuildList();
      });
      actClear.addEventListener('click', () => {
        Array.from(native.options).forEach(o => { o.selected = false; });
        native.dispatchEvent(new Event('change', { bubbles: true }));
        btn.textContent = summary();
        rebuildList();
      });

      search.addEventListener('input', rebuildList);

      const mo = new MutationObserver(() => { btn.textContent = summary(); rebuildList(); });
      mo.observe(native, { childList: true });

      rebuildList();
      btn.textContent = summary();
      selectEl.dataset.msdEnhanced = '1';
      return selectEl;
    }

    // --- Build MSD select from server data (not DOM) to avoid race conditions
    function rebuildTypeButtonsFromData(typesData, typeLabelsData) {
      const select = document.getElementById('tdf-type-select');
      if (!select) return;

      // Use data from server response if available, otherwise fall back to DOM
      let types = [];
      if (typesData && typeLabelsData) {
        // Server provided type data - use it (this is reliable even if shows are still loading)
        types = Object.keys(typesData);
      } else {
        // Fallback: Collect types from results in DOM
        const items = document.querySelectorAll('#tdf-results .show-card[data-post-type]');
        const uniqueTypes = Array.from(new Set(Array.from(items).map(li => li.getAttribute('data-post-type'))));
        types = uniqueTypes;
      }

      // Sort in correct order: page, show, other
      const typeOrder = { 'page': 1, 'show': 2, 'other': 3 };
      types = types.sort((a, b) => (typeOrder[a] || 999) - (typeOrder[b] || 999));

      // Preserve current selection only for types that still exist in new results
      const prev = new Set(Array.from(select.selectedOptions).map(o => o.value));
      const prevFiltered = new Set(types.filter(t => prev.has(t)));

      // Check if all types were selected in the previous results
      const prevOptions = Array.from(select.options).map(o => o.value);
      const prevAvailableTypes = select.dataset.availableTypes ? select.dataset.availableTypes.split(',') : prevOptions;
      const allWereSelected = prev.size > 0 && prevAvailableTypes.length > 0 && prev.size === prevAvailableTypes.length;

      // Rebuild options using server labels if available
      select.innerHTML = types
        .map(t => {
          const label = (typeLabelsData && typeLabelsData[t]) ? typeLabelsData[t] : labelForType(t);
          // Select if: no previous selection, all were previously selected, or this type was selected
          const shouldSelect = prev.size === 0 || allWereSelected || prevFiltered.has(t);
          return `<option value="${t}" ${shouldSelect ? 'selected' : ''}>${label}</option>`;
        })
        .join('');

      // If we had types selected before but none of them exist in new results, select all
      if (prev.size > 0 && prevFiltered.size === 0 && select.options.length > 0) {
        Array.from(select.options).forEach(o => { o.selected = true; });
      }

      // Store the current available types for next comparison
      select.dataset.availableTypes = types.join(',');

      // Enhance (once)
      enhanceMultiSelect(select);

      // Trigger change event to update the enhanced UI's display
      select.dispatchEvent(new Event('change', { bubbles: true }));

      // Change → apply filter
      select.onchange = applyTypeFilter;

      // Reset button → select all
      const resetBtn = document.getElementById('tdf-type-reset');
      if (resetBtn) {
        resetBtn.onclick = () => {
          Array.from(select.options).forEach(o => { o.selected = true; });
          select.dispatchEvent(new Event('change', { bubbles: true }));
        };
      }

      // Initial filter
      applyTypeFilter();
    }

    function applyTypeFilter() {
      const select = document.getElementById('tdf-type-select');
      if (!select) return;
      const selected = Array.from(select.selectedOptions).map(o => o.value);
      const showAll = selected.length === 0 || selected.length === select.options.length;

      document.querySelectorAll('#tdf-results .show-card[data-post-type]').forEach(li => {
        const t = li.getAttribute('data-post-type');
        li.style.display = showAll || selected.includes(t) ? '' : 'none';
      });
    }

    async function fetchResults() {
      const body = new URLSearchParams();
      body.set('action', 'tdf_search');
      body.set('nonce', TDF_SEARCH.nonce);
      body.set('s', state.s || '');
      body.set('orderby', state.orderby || 'relevance');
      body.set('order', state.order || 'DESC');
      body.set('view', state.view || 'list');
      body.set('paged', String(state.paged || 1));

      resultsEl.classList.add('is-loading');
      try {
        const res = await fetch(TDF_SEARCH.ajax_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: body.toString(),
          credentials: 'same-origin',
        });
        const data = await res.json();
        if (data.success) {
          resultsEl.innerHTML = data.data.html;
          paginationEl.innerHTML = data.data.pagination;
          resultsEl.className = `search__results search__results--${state.view}`;
          const countEl = document.getElementById('tdf-results-count');
          if (countEl) countEl.innerHTML = data.data.count;

          // re-bind and rebuild filters using server data (not DOM) to avoid race conditions
          attachPaginationHandlers();
          rebuildTypeButtonsFromData(data.data.types, data.data.type_labels);
          updateMastheadQuery();
          pushUrl();
        } else {
          resultsEl.innerHTML = `<p>${(data.data && data.data.message) ? data.data.message : 'Error.'}</p>`;
        }
      } catch (e) {
        resultsEl.innerHTML = '<p>Something went wrong. Please try again.</p>';
      } finally {
        resultsEl.classList.remove('is-loading');
      }
    }

    function attachPaginationHandlers() {
      const links = paginationEl.querySelectorAll('a.page-numbers');
      links.forEach(a => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          const url = new URL(a.href, window.location.origin);
          const paged = url.searchParams.get('paged') || url.pathname.match(/page\/(\d+)/)?.[1] || '1';
          state.paged = parseInt(paged, 10);
          fetchResults();
        });
      });
    }

    // events
    orderbyEl?.addEventListener('change', () => {
      state.orderby = orderbyEl.value;
      state.paged = 1;
      fetchResults();
    });

    orderDirBtn?.addEventListener('click', () => {
      state.order = state.order === 'ASC' ? 'DESC' : 'ASC';
      orderDirBtn.textContent = state.order === 'ASC' ? 'ASC' : 'DESC';
      state.paged = 1;
      fetchResults();
    });

    viewBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        state.view = btn.dataset.view;
        viewBtns.forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
        fetchResults();
      });
    });

    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = document.getElementById('tdf-search-input');
      state.s = input ? input.value.trim() : '';
      state.paged = 1;
      fetchResults();
    });

    attachPaginationHandlers();
    rebuildTypeButtonsFromData(null, null); // Initial load uses DOM data
    // Don't re-fetch on initial page load - use server-rendered results
    // Only fetch when user interacts with filters/search
  })();
}
